@if (showShell) {
  <!-- Admin shell layout: sidebar + content -->
  <div class="app-shell">
    <app-sidebar></app-sidebar>

    <div class="shell-content">
      <app-topbar></app-topbar>

      <main class="page-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
} @else {
  <!-- Full-page layout: login, unauthorized -->
  <router-outlet></router-outlet>
}
